// extracted by mini-css-extract-plugin
module.exports = {"writing":"Writing_writing__B7cU_"};